import React, { useEffect, useState } from 'react';
import { ACCOUNT_TYPES_MAP } from '@linearb/linjs-common';
import { useDispatch, useSelector } from 'react-redux';
import { syncTeamsTreeSelector } from 'state/selectors/teams';
import { toggleSnackBar } from 'state/callers';
import { allTeams } from 'connected-components/TopBar/TopBar.service';
import SnackBarMessage from 'components/Message';
import validator from 'validator';
import { accountInvitationNew } from 'common/services/invitations.service';
import {
  selectedTeamIdsToAccountScopes,
  isAllTeamsSelected,
  isAllTeamsGroupSelected
} from '../permissions/Permissions.service';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { getAllTeamsGroup, getTreeWhenAllTeamsGroup } from 'common/utils/utils';
import { handleInviteUserError } from './InviteUser.service';

const useInviteUser = () => {
  const [accountTypeId, setAccountTypeId] = useState(ACCOUNT_TYPES_MAP.Primary);
  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const dispatch = useDispatch();
  const history = useHistory();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  let treeTeams = useSelector(syncTeamsTreeSelector);
  const isSendInviteDisabled =
    email.trim() === '' || name.trim() === '' || !validator.isEmail(email);
  const isAdmin = accountTypeId === ACCOUNT_TYPES_MAP.Primary;
  const allTeamsGroup = getAllTeamsGroup(treeTeams);
  const isAllTeamsGroup = !_.isEmpty(allTeamsGroup);
  const allTeamsGroupId = allTeamsGroup?.id;

  // when we are in all teams group mode.
  if (!!treeTeams.length && isAllTeamsGroup) {
    treeTeams = getTreeWhenAllTeamsGroup(treeTeams);
  }

  useEffect(() => {
    if (isAdmin) {
      if (isAllTeamsGroup) {
        setSelectedTeamIds([allTeamsGroupId]);
      } else {
        // TO DO: when all teams group is GA delete this
        setSelectedTeamIds([allTeams.id]);
      }
    }
  }, [isAdmin]);

  const onTeamDropdownChange = selectedTeams =>
    setSelectedTeamIds(
      selectedTeams[0] === allTeams.id
        ? [allTeams.id]
        : selectedTeams.map(({ id }) => id)
    );

  const onSendInvite = async () => {
    try {
      await accountInvitationNew(
        {
          email,
          invitee_name: name,
          account_type_id: accountTypeId,
          scopes: selectedTeamIdsToAccountScopes(
            selectedTeamIds,
            allTeamsGroupId
          )
        },
        isAdmin
      );
      if (
        !isAllTeamsSelected(selectedTeamIds) ||
        !isAllTeamsGroupSelected(selectedTeamIds, allTeamsGroupId)
      ) {
        // Amplitude when updating invitation with RBAC team scopes
        TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
          page: TRACKING.PAGES.SETTINGS,
          page_tab: TRACKING.CLICK.RBAC.SETTINGS.INVITE_USER,
          click_type: TRACKING.CLICK.RBAC.SETTINGS.SAVE_INVITATION,
          setting_value: selectedTeamIds,
          setting_name: TRACKING.CLICK.RBAC.SETTINGS.SAVE_USER_TEAMS_SCOPE,
          event: TRACKING.EVENTS.CLICK
        });
      }
      dispatch(
        toggleSnackBar({
          message: <SnackBarMessage message='Send user invitation succeed' />,
          variant: 'success'
        })
      );
      history.goBack();
    } catch (e) {
      const errorMessage = handleInviteUserError(e);
      dispatch(
        toggleSnackBar({
          message: <SnackBarMessage message={errorMessage} />,
          variant: 'error'
        })
      );
    }
  };

  return {
    accountTypeId,
    setAccountTypeId,
    selectedTeamIds,
    name,
    setName,
    email,
    setEmail,
    setSelectedTeamIds,
    isSendInviteDisabled,
    isAdmin,
    onTeamDropdownChange,
    onSendInvite,
    treeTeams,
    isAllTeamsGroup,
    allTeamsGroupId
  };
};

export default useInviteUser;
